import { CitizenAddressInfo } from "./citizen-address-info";

export class CitizenInfo {
    id: number;
    statusId: number;
    fiscalCode: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    companyName: string;
    vatNumber: string;
    billingSdiCode: string;
    shippingAddress: CitizenAddressInfo;
    billingAddress: CitizenAddressInfo;
    // citizenAddressesInfo: CitizenAddressInfo[];
}
